import {ACTION_CODE} from './_actionCode';
import {DashboardService} from '../../../services';
import {ErrorModel, ResultModel} from '../../../models';
import {LoggerService} from '../../../services';
const FUNCTION_CODE = 'GET_ADMIN_DASHBOARD_COSTS';

export async function getCosts(userData: Record<string, any>, params: string) {
    try {
        LoggerService.logInfo('Action - getCosts - Start');

        const getCosts = await DashboardService.AdminService.getCosts(userData, params);

        LoggerService.logInfo('Action - getCosts - End - Success');

        return ResultModel.newSuccessResult(getCosts);
    }
    catch (error) {
        LoggerService.logInfo('Action - getCosts - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
